// actions/progress.js
export const START_PROGRESS = "START_PROGRESS";
export const STOP_PROGRESS = "STOP_PROGRESS";

export const startProgress = () => ({ type: START_PROGRESS });
export const stopProgress = () => ({ type: STOP_PROGRESS });
